import { Component, OnInit,Input, Output, EventEmitter  } from '@angular/core';
import {FormGroup,FormBuilder,Validators,FormControl, AbstractControl} from '@angular/forms'
@Component({
  selector: 'form-select',
  templateUrl: './form-select.component.html',
  styleUrls: ['./form-select.component.scss']
})
export class FormSelectComponent implements OnInit {

  @Input() descricao: String;

  @Input() placeholder: String;

  @Input() options: any;

  @Input() data: any;

  @Input() value: any;

  @Input() nameControl: String;
  
  @Input() validador: AbstractControl;
  
  @Input() form: FormGroup;

  @Input() obrigatorio: boolean = false;
  
  @Output("valor") valorModificado: EventEmitter<string> = new EventEmitter<string>();

  @Output() mudarSelecao = new EventEmitter();

  public valorCampo:any;
    

  @Input()
  get valor() {
    return this.valorCampo;
  }

  set valor(valor) {
    this.valorCampo = valor;
    this.valorModificado.emit(this.valorCampo);
  }
  
  ngOnInit() {
    
     Object.keys(this.form.controls).forEach(control => {
       if(control == this.nameControl){
         this.validador = this.form.controls[control];
       }
     });
    }   

  seleciona(data) {
    this.valorCampo = data.value;
    console.log(this.valorCampo);
    this.valorModificado.emit(this.valorCampo);
    this.mudarSelecao.emit(data);
  }


}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/form-select/form-select.component.ts